import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FCTTitleInsuranceState } from '@models/title-insurance';

export interface FCTCancelModalData {
	state?: FCTTitleInsuranceState;
	isCommercial?: boolean;
}

@Component({
	selector: 'app-fct-cancel-modal',
	templateUrl: './fct-cancel-modal.component.html',
	standalone: false,
})
export class FctCancelModalComponent implements OnInit {
	public state: FCTTitleInsuranceState;

	constructor(
		private dialogRef: MatDialogRef<FctCancelModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: FCTCancelModalData,
	) {}

	ngOnInit(): void {
		this.state = this.data.state;
	}

	cancel() {
		this.dialogRef.close(true);
	}

	close() {
		this.dialogRef.close(false);
	}
}
